import React from "react";
import "../style/Case.css";
import {
  ArticleImage2,
  insta,
  article11,
  article12,
  article3,
  article4,
  article5,
  product,
} from "../assets";
import { Box, Typography } from "@mui/material";
import ArticleCard from "../component/ArticleCard";

function CaseStudies() {
  const articles = [
    {
      image: article11,
      title: "Why Customer Empathy Matters?",
      description:
        "As a product manager, having customer empathy is paramount for developing solutions that seamlessly integrate into users' lives, ensuring a satisfying user experience.",
      navigateTo:
        "https://www.linkedin.com/posts/yogesh-yadavyy_100daysofpm-productmanagement-customerempathy-activity-7151264480423739392-8-Oe?utm_source=share&utm_medium=member_desktop",
    },
    {
      image: article12,
      title: "The Founder’s Guide to Actually Understanding Users",
      description:
        "Have you ever thought about the seamless experience of streaming on Netflix or effortlessly placing online orders?",
      navigateTo:
        "https://www.linkedin.com/posts/yogesh-yadavyy_artandproductmusings-aws-amazonwebservices-activity-7135830538120015872-PMYF?utm_source=share&utm_medium=member_desktop",
    },
    {
      image: product,
      title: "Why Companies Should Have Product Editors, Not Product Managers",
      description:
        " product management focused on details and schedules, the Product Editor curates a product experience through mindful decision-making.",
      navigateTo:
        "https://www.linkedin.com/posts/yogesh-yadavyy_artandproductmusings-artandproductmusings-activity-7134121645828419585-lqHI?utm_source=share&utm_medium=member_desktop",
    },
    {
      image: insta,
      title: "shipping beats perfection",
      description:
        "Instagram started as a photo app and has evolved into a video and messaging platform. ",
      navigateTo:
        "https://www.linkedin.com/posts/yogesh-yadavyy_artandproductmusings-meta-instagram-activity-7132297100658130945-pZIC?utm_source=share&utm_medium=member_desktop",
    },
    {
      image: article5,
      title: "The concept of the manager's schedule and maker's schedule.",
      description:"Now, my other friend has meetings at the end of the day. This gives him enough time to work and think in between. It turns out different companies organize their developers' time differently. ",
      navigateTo:
        "https://www.linkedin.com/posts/yogesh-yadavyy_productmanagement-managers-developerslife-activity-7130271582312148992-HvRI?utm_source=share&utm_medium=member_desktop",
    },
  ];
  return (
    <Box
      id="Articles"
      p={{ sm: 2, lg: 7 }}
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "450px" },
          height: { xs: "350px", sm: "550px" },
          position: "relative",
          backgroundImage: `url(${ArticleImage2})`,
          backgroundSize: { xs: "50%", sm: "contain" },
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          // backgroundColor: "#000",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          margin: { sm: "10px" },
          filter: "drop-shadow(0px 0px 10px rgba(0,0,0, 0.4))",
        }}
      >
        <Typography
          variant="h1"
          fontFamily={"M PLUS 1, sans-serif"}
          fontSize={{ xs: "2.5rem", sm: "2.5rem", lg: "3rem" }}
          style={{
            color: "#000",
            paddingTop: "60px",
            fontWeight: "bold",
          }}
        >
          Decons of the Articles
        </Typography>
      </Box>

      <div
        className="cardCarouselDiv"
        style={{
          display: "flex",
          width: "100%",
          overflow: "auto",
          alignItems: "center",
          justifyContent: "start",
          msOverflowStyle: "none",
          padding: "3.5rem",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {articles?.map((item, index) => (
          <div
            className="cardDiv"
            key={index}
            style={{ margin: "-15px", transition: "all .3s ease-in-out" }}
          >
            <ArticleCard data={item} />
          </div>
        ))}
      </div>
    </Box>
  );
}

export default CaseStudies;
